import { LocationSearch } from '@/components/events';

interface HeroSectionProps {
  onSearch: (location: {
    zip?: string;
    lat?: number;
    lng?: number;
    displayLabel?: string;
  }) => void;
}

export default function HeroSection({ onSearch }: HeroSectionProps) {
  return (
    <section className="relative bg-brand-dark overflow-hidden">
      {/* Background video — autoplay/muted/loop. JPG poster used by browsers
          that block autoplay or fail to load the MP4. */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/videos/hero-banner.mp4"
        poster="/images/hero/hero-banner.jpg"
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative container-wide py-24 md:py-32">
        <div className="max-w-3xl">
          <h1 className="text-white animate-fade-in">
            Bringing Broadway to you — Nationwide master classes with touring
            cast members
          </h1>
          <div className="animate-fade-in mt-8" style={{ animationDelay: '0.2s' }}>
            <LocationSearch variant="hero" onSearch={onSearch} autoSearch={false} />
          </div>
          <p
            className="text-warm-400 text-sm mt-4 animate-fade-in"
            style={{ animationDelay: '0.4s' }}
          >
            See which Broadway Master Classes On Tour are coming to your area!
          </p>
        </div>
      </div>
    </section>
  );
}
